class Report {

    constructor() {
    }

    static getNameKey() {
        return 'name';
    }

    static getScheduledKey() {
        return 'scheduled';
    }

    static getDescriptionKey() {
        return 'description';
    }

    static getScheduledOptions() {
        return [
            { label: 'Scheduled', value: true },
            { label: 'Unscheduled', value: false },
            { label: 'Undefined', value: undefined },
        ];
    }

    static fromRaw(raw) {
        let report = new Report();
        report.uuid = raw.uuid;
        report.name = raw.name;
        report.scheduled = raw.scheduled;
        report.subscribed = raw.ifSubscribed;
        report.predefined = raw.ifPredefined;
        report.description = raw.description;
        report.parameters = JSON.parse(raw.timeRange);

        return report;
    }

    toRaw() {
        return {
            uuid: this.uuid,
            name: this.name,
            scheduled: this.scheduled,
            subscribed: this.subscribed,
            predefined: this.predefined,
            description: this.description,
        }
    }
}

module.exports = Report;



// WEBPACK FOOTER //
// ./src/azurebackup/model/Report.js